import type { Me } from '../api';
import { AskButton } from './ai/AskButton';
import { NotificationBell } from './NotificationBell';
import { UserMenu } from './UserMenu';

/**
 * The right-hand end of every top bar (§23 M12.7, the Microsoft 365 pattern): Ask (§32, when AI is on), notifications
 * and the avatar menu.
 * Admin, Platform, light / dark and language live in the avatar menu; Learning is in the left sidebar.
 */
export function TopbarTools({ me }: { me: Me }) {
  return (
    <>
      <AskButton />
      <NotificationBell />
      <UserMenu me={me} />
    </>
  );
}
